export default __webpack_public_path__ + "static/media/client48.9750bf4f.png";